import React, { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react";
import RootStore from "SandboxViewerComponent/src/stores/RootStore";
import ScaleBar from "@arcgis/core/widgets/ScaleBar";
import {
  Container,
  FormLabel,
  Grid,
  IconButton,
  Link,
  Menu,
  MenuItem,
  styled,
} from "@mui/material";
import * as watchUtils from "@arcgis/core/core/watchUtils";
import DragableIframe from "components/DragableIframe";
import MenuIcon from "@mui/icons-material/Menu";
import AppBarSystemInfoModal from "./AppBarSystemInfoModal";
import { helpUrl, downloadUrl, feedbackUrl } from "configs/config";

const HELP_LONG_PRESS_DELAY = 700;

const ScaleContainer = styled("div")({
  width: 120,
  paddingLeft: 15,
  scrollPaddingBottom: 3,
});

const StyledBottomBar = styled(Container)({
  position: "absolute",
  bottom: 2,
  width: "100% !important",
  maxWidth: "100% !important",
  background: "white",
  height: 54,
  boxShadow:
    "0px -2px 4px -1px rgb(0 0 0 / 20%), 0px -4px 5px 0px rgb(0 0 0 / 14%), 0px -1px 10px 0px rgb(0 0 0 / 12%)",
});
const { uiStore, mapStore } = RootStore;

function BottomBar(props) {
  const { mobile } = RootStore.uiStore.BBStore;
  uiStore.setBottomBarHeight(54);
  const [scaleText, setScaleText] = useState("");
  const scalebarRef = useRef();
  const [anchorEl, setAnchorEl] = useState(null);
  const [openSystemInfoModal, setOpenSystemInfoModal] = useState(false);
  const helpLongPressTimerRef = useRef(null);
  const helpLongPressTriggeredRef = useRef(false);

  const cancelHelpLongPress = () => {
    if (helpLongPressTimerRef.current !== null) {
      window.clearTimeout(helpLongPressTimerRef.current);
      helpLongPressTimerRef.current = null;
    }
  };

  const startHelpLongPress = (event) => {
    if (event.button !== undefined && event.button !== 0) return;

    cancelHelpLongPress();
    helpLongPressTriggeredRef.current = false;
    helpLongPressTimerRef.current = window.setTimeout(() => {
      helpLongPressTimerRef.current = null;
      helpLongPressTriggeredRef.current = true;
      setOpenSystemInfoModal(true);
    }, HELP_LONG_PRESS_DELAY);
  };

  const handleHelpClick = (event) => {
    cancelHelpLongPress();
    if (!helpLongPressTriggeredRef.current) return false;

    event.preventDefault();
    event.stopPropagation();
    helpLongPressTriggeredRef.current = false;
    return true;
  };

  const handleHelpContextMenu = (event) => {
    if (
      helpLongPressTimerRef.current !== null ||
      helpLongPressTriggeredRef.current
    ) {
      event.preventDefault();
    }
  };

  const mapReady = mapStore.mapReady;

  const options = [
    { label: "Systeminfo", action: () => setOpenSystemInfoModal(true) },
    { label: "Einführung", action: () => window.startIntro?.() },
    { label: "Hilfe", url: helpUrl },
    { label: "Download", url: downloadUrl },
    { label: "Feedback", url: feedbackUrl },
    { label: "Barrierefreiheit", url: "Barrierefreiheit.html" },
    { label: "Impressum", url: "Impressum.html" },
  ];

  const open = !!anchorEl;
  useEffect(() => {
    if (mapReady && scalebarRef.current) {
      watchUtils.pausable(mapStore.mapView, "scale", function (scale) {
        setScaleText(
          `1 : ${new Intl.NumberFormat("de-DE", {
            useGrouping: true,
          }).format(Math.round(scale))}`
        );
      });

      if (!scalebarRef.current.firstChild)
        new ScaleBar({
          view: mapStore.mapView,
          container: scalebarRef.current,
          unit: "metric",
        });
    }
  }, [mapReady]);

  // useEffect(() => {
  //   if (scalebarRef.current) {
  //     new ScaleBar({
  //       view: mapStore.mapView,
  //       container: scalebarRef.current,
  //       unit: "metric",
  //     });
  //   }
  // }, [scalebarRef.current]);

  useEffect(() => {
    if (scalebarRef.current && !scalebarRef.current.firstChild)
      new ScaleBar({
        view: mapStore.mapView,
        container: scalebarRef.current,
        unit: "metric",
      });
  }, [mobile]);

  useEffect(
    () => () => {
      if (helpLongPressTimerRef.current !== null) {
        window.clearTimeout(helpLongPressTimerRef.current);
      }
    },
    []
  );

  if (!mapStore.mapReady) {
    return (
      <div /*className={classes.root}*/>
        <StyledBottomBar>loading</StyledBottomBar>
      </div>
    );
  }

  const scaleBarElement = <div ref={scalebarRef} />;

  return (
    <StyledBottomBar>
      {mobile && (
        <div
          style={{
            position: "absolute",
            left: 15,
            top: "50%",
            transform: "translateY(-50%)",
          }}
        >
          <div style={{ float: "left", width: 120, marginRight: 10 }}>
            {scaleBarElement}
          </div>
          <div style={{ float: "left" }}>
            <FormLabel>{scaleText}</FormLabel>
          </div>
        </div>
      )}
      {!mobile && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            height: 54,
          }}
        >
          <div
            style={{
              flexGrow: 0,
              width: 250,
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <ScaleContainer id="scaleContainer">
              {scaleBarElement}
            </ScaleContainer>
            <div>
              <FormLabel>{scaleText}</FormLabel>
            </div>
          </div>
          <div
            style={{
              flexGrow: 0,
              width: 625,
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >

            <Grid item>
              <Link
                component="button"
                onClick={() => window.startIntro?.()}
                title="Interaktive Einführung in NIKLIS starten"
              >
                Einführung
              </Link>
            </Grid>
            <Grid item>
              <Link
                href={helpUrl}
                title="Weitergehende Informationen"
                target="Hilfe"
                onPointerDown={startHelpLongPress}
                onPointerUp={cancelHelpLongPress}
                onPointerCancel={cancelHelpLongPress}
                onPointerLeave={cancelHelpLongPress}
                onContextMenu={handleHelpContextMenu}
                onClick={handleHelpClick}
              >
                Hilfe
              </Link>
            </Grid>
            <Grid item>
              <Link
                href={downloadUrl}
                title="Download von weiterführenden Informationen"
                target="download"
              >
                Download
              </Link>
            </Grid>
            <Grid item>
              <Link
                href={feedbackUrl}
                title="Hier klicken, um eine Feedback-Mail zu verschicken"

              >
                Feedback
              </Link>
            </Grid>
            <Grid item>
              <DragableIframe
                linkText="Barrierefreiheit"
                titleText="Erklärung zur Barrierefreiheit"
                url="Barrierefreiheit.html"
                innerHeight={300}
                innerWidth={500}
              />
            </Grid>
            <Grid item style={{ paddingRight: 15 }}>
              <DragableIframe
                url="Impressum.html"
                linkText="Impressum"
                titleText="Impressum &amp; Datenschutzerklärung"
                innerHeight={300}
                innerWidth={500}
              />
            </Grid>
          </div>
        </div>
      )}
      {mobile && (
        <IconButton
          style={{
            position: "absolute",
            right: 10,
            top: 54 / 2,
            transform: "translateY(-50%)",
          }}
          onClick={(e) => {
            setAnchorEl(e.currentTarget);
          }}
        >
          <MenuIcon />
        </IconButton>
      )}
      {mobile && (
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={() => {
            setAnchorEl(null);
          }}
        >
          {options.map((option) => {
            const item = (
              <MenuItem
                key={option.label}
                selected={false}
                onPointerDown={
                  option.label === "Hilfe" ? startHelpLongPress : undefined
                }
                onPointerUp={
                  option.label === "Hilfe" ? cancelHelpLongPress : undefined
                }
                onPointerCancel={
                  option.label === "Hilfe" ? cancelHelpLongPress : undefined
                }
                onPointerLeave={
                  option.label === "Hilfe" ? cancelHelpLongPress : undefined
                }
                onContextMenu={
                  option.label === "Hilfe" ? handleHelpContextMenu : undefined
                }
                onClick={(event) => {
                  if (
                    option.label === "Hilfe" &&
                    handleHelpClick(event)
                  ) {
                    setAnchorEl(null);
                    return;
                  }
                  if (option.action) {
                    option.action();
                  } else if (!option.download) {
                    window.open(option.url, "_blank").focus();
                  }
                  setAnchorEl(null);
                }}
              >
                {option.label}
              </MenuItem>
            );
            if (option.download) {
              return (
                <Link href={option.url} download={option.url}>
                  {item}
                </Link>
              );
            }
            return item;
          })}
        </Menu>
      )}

      <AppBarSystemInfoModal
        openModal={openSystemInfoModal}
        handleClose={() => setOpenSystemInfoModal(false)}
      />
    </StyledBottomBar>
  );
}
export default observer(BottomBar);
